import { get } from 'vio-libs';
export function getKEXCommunity(organization, consumerAPI = false) {
    if (!consumerAPI) {
        return get(`kex-community?organization=${organization}`);
    }
    return get(`v1/${organization}/kex/community`, undefined, true);
}
